angular.module("vgresiduos").controller("CollectionRequestDisposalEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes/destinacao/${$stateParams.id}`);
		};
	}
]);
